import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJusticeOfThePeaceinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M32 4v54.686M23 59h18m-1-25h14c-.634 3.418-3.527 6-7 6s-6.366-2.582-7-6zm-30 0h14c-.634 3.418-3.527 6-7 6s-6.366-2.582-7-6z",
			strokeLinecap: "square"
		}), /* @__PURE__ */ _jsx("path", { d: "M17 34V14a4 4 0 0 1 4-4h22a4 4 0 0 1 4 4v20" })]
	})
});
export default SvgJusticeOfThePeaceinline;
